import { cx } from "@emotion/css";

export const DefaultViewBackground = ({ className, children, ...rest }) => {
	return (
		<div
			className={cx(className, "content-box flex flex-col gap-24")}
			{...rest}
		>
			{children}
		</div>
	);
};

function DefaultScoreView({
	className,
	Details,
	Actions,
	children = null,
	...rest
}) {
	return (
		<DefaultViewBackground
			className={className}
			data-test-id="exam-list-item"
			{...rest}
		>
			<div className="flex w-100">
				{Details}
				{Actions}
			</div>
			{children}
		</DefaultViewBackground>
	);
}

export default DefaultScoreView;
